import { CommonModalProps } from 'vibo-ui/Modal';

export interface AssignPlaylistModalProps extends CommonModalProps {
  assigneType: AssigneType;
}

export enum AssigneType {
  event = 'event',
  template = 'template',
  eventSections = 'eventSections',
  templateSections = 'templateSections',
  favoriteSections = 'favoriteSections',
}
